export default __webpack_public_path__ + "static/media/vertical.e14c4447.png";